<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <!-- Header with add icon -->
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.study phase list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Study Phase" style="cursor: pointer;"
          @click="addNewRow" />
        <div class="tool-tip mt-2">Add Study Phase</div>
      </div>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Name <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>Type</th>
                <th>Active</th>
                <th>Description</th>
                <th class="text-center sticky-column">Edit</th>
                <th class="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              <!-- New Row for creation -->
              <tr v-if="isAddingNew">
                <td>
                  <input v-model="newRow.name" class="form-control" type="text" @input="clearNewFieldError('name')" />
                  <div v-if="newRowErrors.name" class="text-danger">{{ newRowErrors.name }}</div>
                </td>
                <td>
                  <input v-model="newRow.type" class="form-control" type="text" />
                </td>
                <td>
                  <select class="form-select" v-model="newRow.active">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <td>
                  <textarea v-model="newRow.description" class="form-control" rows="3"></textarea>
                </td>
                <td class="text-center sticky-column">
                  <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                  <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                </td>
                <td></td>
              </tr>

              <!-- No data row -->
              <tr v-if="!isAddingNew && studyPhases.length === 0">
                <td colspan="6" class="text-center">No data available.</td>
              </tr>

              <!-- Existing rows -->
              <tr v-for="(phase, index) in studyPhases" :key="phase.phaseId">
                <!-- Name -->
                <td v-if="editIndex !== index">{{ phase.name }}</td>
                <td v-else>
                  <input v-model="editableRow.name" class="form-control" type="text" @input="clearFieldError('name')" />
                  <div v-if="validationErrors.name" class="text-danger">{{ validationErrors.name }}</div>
                </td>
                <!-- Type -->
                <td v-if="editIndex !== index">{{ phase.type }}</td>
                <td v-else>
                  <input v-model="editableRow.type" class="form-control" type="text" @input="clearFieldError('type')" />
                </td>
                <!-- Active -->
                <td v-if="editIndex !== index">{{ phase.active ? "Yes" : "No" }}</td>
                <td v-else>
                  <select class="form-select" v-model="editableRow.active">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <!-- Description -->
                <td v-if="editIndex !== index">
                  <div class="wrap-text">{{ phase.description }}</div>
                </td>
                <td v-else>
                  <textarea v-model="editableRow.description" class="form-control" rows="3"></textarea>
                </td>
                <!-- Edit Actions -->
                <td class="text-center sticky-column">
                  <template v-if="editIndex !== index">
                    <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                      @click.prevent="editRow(index, phase)"></i>
                  </template>
                  <template v-else>
                    <i class="fa fa-check action-icon text-success" @click="updateRow(phase.id)" title="Update"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                  </template>
                </td>
                <!-- Delete -->
                <td class="text-center">
                  <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                    @click="deleteRow(phase.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mx-0" v-if="studyPhases.length > 0">
          <div class="col-lg-12 mx-0 px-0">
            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                  @update:modelValue="loadPage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}

.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>

<script src="./StudyPhaseManagement.js"></script>